import type { TrustedVerifier } from '@/types/verification'

export const CONSTELLATION_BASE_URL = 'https://constellation.microcosm.blue'

export const VERIFICATION_STORAGE_KEY = 'mackinac:verificationPreferences'

export const VERIFICATION_STALE_TIME = 10 * 60 * 1000 // 10 minutes

export const VERIFIERS_CUSTOMIZED_KEY = 'mackinac:verifiersCustomized'

export const FALLBACK_TRUSTED_VERIFIERS: TrustedVerifier[] = [
    { did: 'did:plc:z72i7hdynmk6r22z27h6tvur', label: 'bsky.app', handle: 'bsky.app' },
    { did: 'did:plc:eclio37ymobqex2ncko63h4r', label: 'nytimes.com', handle: 'nytimes.com' },
    { did: 'did:plc:inz4fkbbp7ms3ixufw6xuvdi', label: 'wired.com', handle: 'wired.com' },
    {
        did: 'did:plc:b2kutgxqlltwc6lhs724cfwr',
        label: 'theathletic.com',
        handle: 'theathletic.com',
    },
]
